<div class="notice-banner-container" *ngIf="isVisible && noticeBanner">
  <div class="container">
    <div class="notice-banner">
      <div class="banner-text">
        <div class="d-flex flex-row">
          <mat-icon svgIcon="error-warning"></mat-icon>
          <div>
            <span class="bold-text error">{{noticeBanner.title}}</span>
            <div>
              <span>{{noticeBanner.noticeText}}</span>
              <span class="bold-text" *ngIf="noticeBanner?.redirectUrl">
                <a *ngIf="isExternalUrl && isPrimary" href="{{noticeBanner.redirectUrl}}">{{noticeBanner.enrollText}}</a>
                <a *ngIf="!isExternalUrl && isPrimary" routerLink="{{noticeBanner.redirectUrl}}"
                   routerLinkActive="active">{{noticeBanner.enrollText}}</a>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="banner-icon">
        <mat-icon (click)="close()" svgIcon="x-close-1"></mat-icon>
      </div>
    </div>
  </div>
</div>
